module.exports = __webpack_public_path__ + "static/fail-modal-icon.c1b804c6.png";